module.exports = __webpack_public_path__ + "static/clients_gallery_tasks@2x-fd9183437887bbd3ad466e26136b2ce8.png";